function validatePassword(campo) {
	var letrasMaiusculas = /[A-Z]/;
	var letrasMinusculas = /[a-z]/;
	var numeros = /[0-9]/;
	var caracteresEspeciais = /([~,!,@,#,),(,{,},,,.,;,:,º,ª,¬,¢,£,",',²,³,¹,$,%,^,&,*,-,_,+,=,?,>,<,/,|])/;

	var auxMaiuscula = 0;
	var auxMinuscula = 0;
	var auxNumero = 0;
	var auxEspecial = 0;

	for (var i = 0; i < campo.length; i++) {
		if (letrasMaiusculas.test(campo[i])) {
			auxMaiuscula = 1;
		} else if (letrasMinusculas.test(campo[i])) {
			auxMinuscula = 1;
		} else if (numeros.test(campo[i])) {
			auxNumero = 1;
		} else if (caracteresEspeciais.test(campo[i])) {
			auxEspecial = 1;
		}
	}

	var forca = auxMaiuscula + auxMinuscula + auxNumero + auxEspecial;

	if (campo.length < 8) {
		return [0, "#fb6a6a"];
	}

	if (forca <= 1) {
		return [25, "#fb6a6a"];
	}

	if (forca === 2) {
		return [50, "#f5e353"];
	}

	if (forca === 3) {
		return [75, "#a8d1a8"];
	}

	if (forca === 4) {
		return [100, "#53b353"];
	}
}

export { validatePassword };
